import API from 'api/helpers/client';
import type {
  SmartyAutoCompleteRequest,
  SmartyAutoCompleteResponse,
  SmartyValidateAddressRequest,
  SmartyValidateAddressResponse,
} from './smarty.types';

export const getSmartyAddress = async (
  body: SmartyAutoCompleteRequest,
  controller?: AbortController,
): Promise<SmartyAutoCompleteResponse[]> => {
  const { data } = await API.post(
    `smarty/complete-address`,
    {
      ...body,
    },
    { signal: controller?.signal },
  );

  return data ?? [];
};

export const validateSmartyAddress = async (
  body: SmartyValidateAddressRequest,
): Promise<SmartyValidateAddressResponse> => {
  const { data } = await API.post(`smarty/validate-address`, {
    ...body,
  });

  return data ?? [];
};
